export enum AssetDataCardVariant {
  DEFAULT = 'DEFAULT',
  CONDENSED = 'CONDENSED',
}

export type AssetDataCardProps = {
  variant: AssetDataCardVariant;
  addedBy: string;
  title?: string;
  isFavorite?: boolean;
  onFavoriteClick?: () => void;
  onLinkClick?: () => void;
  onProfileLinkClick?: (username: string) => void;
  isCommunityItem?: boolean;
  showFavorite?: boolean;
  link?: string;
  thumbnailUrl?: string;
  favoriteCount?: number;
  description?: {
    content: string;
    username: string;
    avatarUrl?: string;
  };
};
